import {useIsWeb} from '@eCommerce/frontend-legacy-shared-library-native';
import {View, Text} from 'native-base';
import React from 'react';
import FA5ProIcon from 'react-native-vector-icons/FontAwesome5Pro';
import InnerCircleText from '../InnerCircleText/InnerCircleText';
import {useTheme} from 'styled-components/native';

export interface SevenStarsInnerCircleProps {
  tierCredits: number;
}

const SevenStarsInnerCircle: React.FC<SevenStarsInnerCircleProps> = ({
  tierCredits,
}) => {
  const theme = useTheme() as any;
  const {white} = theme.colors;
  const isWeb = useIsWeb();
  const sevenStarsExperienceCreditCost = 250000;
  const experienceCreditCount = Math.floor(
    tierCredits / sevenStarsExperienceCreditCost
  );
  const oneCreditOrLess = tierCredits < sevenStarsExperienceCreditCost * 2;

  return (
    <View alignItems="center" justifyContent="center">
      <View justifyContent="center" alignItems="center" mb="8px">
        <FA5ProIcon size={40} color={white} name="shield" solid />
        <View position="absolute">
          <Text
            fontFamily="heading"
            fontWeight="bold"
            fontSize="14px"
            lineHeight={isWeb ? '18px' : undefined}
            color="#6E0C1D">
            {experienceCreditCount}
          </Text>
        </View>
      </View>
      <InnerCircleText text="Experience" isSevenStars={true} />
      <InnerCircleText
        text={`Credit${oneCreditOrLess ? '' : 's'}`}
        isSevenStars={true}
      />
    </View>
  );
};

export default SevenStarsInnerCircle;
